/** Fixed seek points in seconds, matching the backend's stored-frame sampling. */
export const PDQ_FRAME_TIMES = [1, 5, 10, 15, 20] as const;
export const PDQ_FRAME_DIMENSION = 512;
export const PDQ_JPEG_QUALITY = 0.92;
